<!-- Filters Section -->
<div class="filters-section" [class.sticky-active]="isSticky()">
  <!-- Sticky pin gomb -->
  @if (allowSticky && pageName) {
    <button mat-icon-button 
            class="sticky-pin-btn"
            (click)="toggleSticky()"
            [matTooltip]="isSticky() ? 'Szűrő feloldása' : 'Szűrő rögzítése'"
            matTooltipPosition="left">
      <mat-icon [class.pinned]="isSticky()">{{ isSticky() ? 'push_pin' : 'push_pin' }}</mat-icon>
    </button>
  }

  <!-- Basic Filters Row -->
  <div class="filters-row">
    <!-- Search Input -->
    <mat-form-field class="filter-input">
      <mat-label>Keresés</mat-label>
      <input matInput 
             [(ngModel)]="currentFilter.searchTerm" 
             (input)="onSearchChange()"
             [placeholder]="customSearchPlaceholder || (showOnlySearch ? 'Keresés ügyfelekben...' : 'Keresés szerződésekben...')">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    @if (!showOnlySearch) {
      <!-- Status Filter -->
      <mat-form-field class="filter-select">
        <mat-label>{{ customStatusLabel || (useLogsLabels ? 'Típus' : 'Státusz') }}</mat-label>
        <mat-select [(ngModel)]="currentFilter.statusFilter" 
                    (selectionChange)="onStatusFilterChange()"
                    multiple
                    [disabled]="lockStatusFilter"
                    placeholder="{{ customStatusLabel ? 'Válassz ' + customStatusLabel.toLowerCase() + '...' : (useLogsLabels ? 'Válassz típusokat...' : 'Válassz státuszokat...') }}">
          @for (option of statusOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
        @if (lockStatusFilter && customStatusLabel) {
          <mat-hint>Csak saját {{ customStatusLabel.toLowerCase() }} rekordok megjelenítése</mat-hint>
        }
      </mat-form-field>

      <!-- Assignee Filter (Call Center) or Biztosító Filter (Contracts) -->
      @if (useAssigneeFilter) {
        <mat-form-field class="filter-select" [class.assignee-multi-active]="isAssigneeMultiSelected()">
          <mat-label>Hozzárendelve</mat-label>
          <mat-select [(ngModel)]="currentFilter.assigneeFilter" 
                      (selectionChange)="onAssigneeSelectionChange($event)"
                      multiple
                      [disabled]="lockAssigneeFilter"
                      placeholder="Válassz hozzárendelteket...">
            <mat-select-trigger>{{ getAssigneeDisplayText() }}</mat-select-trigger>
            <mat-option value="all">Összes</mat-option>
            <mat-option value="unassigned">Nincs hozzárendelve</mat-option>
            @for (user of callCenterStaff; track user.username) {
              <mat-option [value]="user.username">{{ user.username || user.fullname }}{{ !user.is_active ? ' (inaktív)' : '' }}</mat-option>
            }
          </mat-select>
          <mat-icon matSuffix>assignment_ind</mat-icon>
          @if (lockAssigneeFilter) {
            <mat-hint>Csak saját rekordok megjelenítése</mat-hint>
          }
        </mat-form-field>
      } @else {
        <mat-form-field class="filter-select">
          <mat-label>{{ customBiztositoLabel || (useLogsLabels ? 'Felhasználó' : 'Biztosító') }}</mat-label>
          <mat-select [(ngModel)]="currentFilter.biztositoFilter" 
                      (selectionChange)="onBiztositoFilterChange()"
                      multiple
                      [disabled]="lockUserFilter"
                      placeholder="{{ customBiztositoLabel ? 'Válassz ' + customBiztositoLabel.toLowerCase() + '...' : (useLogsLabels ? 'Válassz felhasználókat...' : 'Válassz biztosítókat...') }}">
            @for (option of (useLogsLabels ? userOptions : biztositoOptions); track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
          @if (lockUserFilter && useLogsLabels) {
            <mat-hint>Csak saját bejegyzések megjelenítése</mat-hint>
          }
        </mat-form-field>
      }

      <!-- Clear Filters Button -->
      <button mat-icon-button 
              color="accent" 
              (click)="onClearFilters()"
              class="clear-filters-btn"
              matTooltip="Szűrők törlése">
        <mat-icon>filter_alt_off</mat-icon>
      </button>
    } @else {
      <!-- Clear Search Button for search-only mode -->
      <button mat-icon-button 
              color="accent" 
              (click)="onClearFilters()"
              class="clear-filters-btn"
              matTooltip="Keresés törlése">
        <mat-icon>clear</mat-icon>
      </button>
    }
  </div>

  <!-- Advanced Filters Expansion Panel -->
  @if (!showOnlySearch) {
    <mat-expansion-panel 
      [(expanded)]="isAdvancedFiltersExpanded"
      class="advanced-filters-panel">
    
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>tune</mat-icon>
        Részletes szűrők
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="advanced-filters-content">
      <div class="advanced-filters-row">
        
        @if (useAssigneeFilter) {
          <!-- Call Center Date Filters -->
          
          <!-- Call Date From Filter -->
          <mat-form-field class="filter-date">
            <mat-label>Hívás dátuma (tól)</mat-label>
            <input matInput 
                   [matDatepicker]="callDateFromPicker" 
                   [(ngModel)]="currentFilter.dateFromFilter"
                   (dateChange)="onDateFromChange()"
                   placeholder="éééé.hh.nn">
            <mat-datepicker-toggle matSuffix [for]="callDateFromPicker"></mat-datepicker-toggle>
            <mat-datepicker #callDateFromPicker></mat-datepicker>
          </mat-form-field>

          <!-- Call Date To Filter -->
          <mat-form-field class="filter-date">
            <mat-label>Hívás dátuma (ig)</mat-label>
            <input matInput 
                   [matDatepicker]="callDateToPicker" 
                   [(ngModel)]="currentFilter.dateToFilter"
                   (dateChange)="onDateToChange()"
                   placeholder="éééé.hh.nn">
            <mat-datepicker-toggle matSuffix [for]="callDateToPicker"></mat-datepicker-toggle>
            <mat-datepicker #callDateToPicker></mat-datepicker>
          </mat-form-field>

          <!-- Főtevékenység Filter (autocomplete + chipek) -->
          @if (showMainActivityFilter) {
            <mat-form-field class="filter-main-activity">
              <mat-label>Főtevékenység</mat-label>
              <mat-chip-grid #mainActivityChipGrid aria-label="Kiválasztott főtevékenységek">
                @for (activity of currentFilter.mainActivityFilter; track activity) {
                  <mat-chip-row (removed)="removeMainActivity(activity)">
                    {{ activity }}
                    <button matChipRemove [attr.aria-label]="activity + ' eltávolítása'">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
              </mat-chip-grid>
              <input #mainActivityInputEl
                     placeholder="Kezdje el gépelni..."
                     [matChipInputFor]="mainActivityChipGrid"
                     [matAutocomplete]="mainActivityAuto"
                     [ngModel]="mainActivityInput"
                     [ngModelOptions]="{ standalone: true }"
                     (ngModelChange)="onMainActivityInput($event)"
                     (focus)="onMainActivityFocus()">
              <mat-autocomplete #mainActivityAuto="matAutocomplete"
                                (optionSelected)="onMainActivitySelected($event, mainActivityInputEl)">
                <!-- A javaslatlista minden keresésnél teljesen kicserélődik, ezért index szerinti track -->
                @for (activity of mainActivityOptions; track $index) {
                  <mat-option [value]="activity">{{ activity }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

        } @else {
          <!-- Contract Filters (original) -->
          
          <!-- Product Filter -->
          @if (!hideProductFields) {
            <mat-form-field class="filter-select">
              <mat-label>Termék</mat-label>
              <mat-select [(ngModel)]="currentFilter.productFilter" 
                          (selectionChange)="onProductFilterChange()"
                          multiple
                          placeholder="Válassz termékeket...">
                @for (option of productOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <!-- Payment Frequency Filter -->
          @if (!hideProductFields) {
            <mat-form-field class="filter-select">
              <mat-label>Fizetési gyakoriság</mat-label>
              <mat-select [(ngModel)]="currentFilter.paymentFrequencyFilter" 
                          (selectionChange)="onPaymentFrequencyFilterChange()"
                          multiple
                          placeholder="Válassz fizetési gyakoriságokat...">
                @for (option of paymentFrequencyOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <!-- Currency Filter -->
          @if (!hideProductFields) {
            <mat-form-field class="filter-select">
              <mat-label>Pénznem</mat-label>
              <mat-select [(ngModel)]="currentFilter.currencyFilter" 
                          (selectionChange)="onCurrencyFilterChange()"
                          multiple
                          placeholder="Válassz pénznemeket...">
                @for (option of currencyOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <!-- Date From Filter -->
          <mat-form-field class="filter-date">
            <mat-label>{{ customDateFromLabel || (useLogsDateLabels ? 'Kezdő dátum (tól)' : 'Indulás dátuma (tól)') }}</mat-label>
            <input matInput 
                   [matDatepicker]="dateFromPicker" 
                   [(ngModel)]="currentFilter.dateFromFilter"
                   (dateChange)="onDateFromChange()"
                   placeholder="éééé.hh.nn">
            <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
            <mat-datepicker #dateFromPicker></mat-datepicker>
          </mat-form-field>

          <!-- Date To Filter -->
          <mat-form-field class="filter-date">
            <mat-label>{{ customDateToLabel || (useLogsDateLabels ? 'Vég dátum (ig)' : 'Indulás dátuma (ig)') }}</mat-label>
            <input matInput 
                   [matDatepicker]="dateToPicker" 
                   [(ngModel)]="currentFilter.dateToFilter"
                   (dateChange)="onDateToChange()"
                   placeholder="éééé.hh.nn">
            <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
            <mat-datepicker #dateToPicker></mat-datepicker>
          </mat-form-field>
          
          <!-- Policy Number Filter -->
          @if (!hidePolicyNumberField) {
            <mat-form-field class="filter-input">
              <mat-label>Kötvényszám</mat-label>
              <input matInput 
                     [(ngModel)]="currentFilter.policyNumberFilter" 
                     (input)="onPolicyNumberFilterChange()"
                     placeholder="Kötvényszám keresése...">
              <mat-icon matSuffix>assignment</mat-icon>
            </mat-form-field>
          }

          <!-- Illustration Status Filter -->
          @if (showIllustrationStatusFilter) {
            <mat-form-field class="filter-select">
              <mat-label>Státusz</mat-label>
              <mat-select [(ngModel)]="currentFilter.illustrationStatusFilter" 
                          (selectionChange)="onIllustrationStatusFilterChange()"
                          multiple
                          placeholder="Válassz státuszokat...">
                @for (option of illustrationStatusOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
              <mat-icon matSuffix>flag</mat-icon>
            </mat-form-field>
          }
        }

      </div>
    </div>

    </mat-expansion-panel>
  }
</div>